import { JSX } from 'react';

export const passthroughVent = {
	cutout: ({ x = 0, y = 0, opacity = 1 }: {x?: number; y?: number; opacity?: number;}): JSX.Element => {
		return <polygon points={`
			${0}, ${1}
			${6}, ${1}
			${6}, ${0}
			${10}, ${0}
			${10}, ${2}
			${0}, ${2}
		`} fill="white" opacity={opacity} transform={`translate(${x}, ${y})`}/>;
	}
};
